// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.notify-test.stage.monatest.icu/auto-open-api-spec.yaml 1.8.23
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2025-07-24T12:44:37.585706+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer for validating resolve notification
 * @see #/components/schemas/NotificationQueryRequest - reference to schema in open-api-spec.yaml
 * @since 2025-07-24T12:44:37.585706+03:00[Europe/Kiev]
 * @version 1.8.23
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface NotificationQueryRequest {
    /**
     * Encounter id for notifications. Typically the Encounter-ID.
     * @dataFormat uuid
     */
    encounter_id?: string;
    /**
     * Read Status of the notification. True for read and False for unread.
     *
     */
    read_status?: boolean | null;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for NotificationQueryRequest
 */
export namespace NotificationQueryRequest {
    /**
     * NotificationQueryRequest Frontend Model with camelCase properties
     * @since 2025-07-24T12:44:37.585706+03:00[Europe/Kiev]
     * @version 1.8.23
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * Encounter id for notifications. Typically the Encounter-ID.
         * @dataFormat uuid
         */
        encounterId?: string;
        /**
         * Read Status of the notification. True for read and False for unread.
         * @type boolean (`dataFormat` is missing)
         */
        readStatus?: boolean | null;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * NotificationQueryRequest DTO
     * Transforms NotificationQueryRequest model from/to API object
     * @since 2025-07-24T12:44:37.585706+03:00[Europe/Kiev]
     * @version 1.8.23
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend NotificationQueryRequest model */
        static toModel(obj: NotificationQueryRequest): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend NotificationQueryRequest model */
        static toApi(obj: Model): NotificationQueryRequest {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as NotificationQueryRequest;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
